import { create } from "zustand";
import type { User } from "../types/models";

// Клиентское состояние сессии. JWT в localStorage["kq_token"] (как legacy app-core.js setToken/authToken).
// Серверные данные (catalog/боты) — в TanStack Query, НЕ здесь.
const TOKEN_KEY = "kq_token";

interface AuthState {
  token: string;
  user: User | null;
  /** Успешный логин/регистрация: сохранить токен + пользователя. */
  setSession: (token: string, user: User) => void;
  /** Обновить пользователя (после GET /api/me при восстановлении сессии). */
  setUser: (user: User | null) => void;
  /** Сброс сессии (logout или 401 на защищённом эндпоинте → экран входа). */
  clearSession: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: localStorage.getItem(TOKEN_KEY) || "",
  user: null,
  setSession: (token, user) => {
    localStorage.setItem(TOKEN_KEY, token);
    set({ token, user });
  },
  setUser: (user) => set({ user }),
  clearSession: () => {
    localStorage.removeItem(TOKEN_KEY);
    set({ token: "", user: null });
  },
}));
